import React from 'react';
import './AlertModal.css';
import { FiX, FiAlertCircle, FiCheckCircle, FiInfo } from 'react-icons/fi';

export type AlertType = 'error' | 'warning' | 'success' | 'info';

export interface AlertModalProps {
  isOpen: boolean;
  title: string;
  message: string | React.ReactNode;
  type?: AlertType;
  onClose: () => void;
  okText?: string;
  onOk?: () => void;
  showCancel?: boolean;
  cancelText?: string;
  onCancel?: () => void;
}

const AlertModal: React.FC<AlertModalProps> = ({
  isOpen,
  title,
  message,
  type = 'info',
  onClose,
  okText = 'OK',
  onOk,
  showCancel = false,
  cancelText = 'Cancel',
  onCancel,
}) => {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'error':
        return <FiAlertCircle className="alert-icon alert-icon-error" />;
      case 'warning':
        return <FiAlertCircle className="alert-icon alert-icon-warning" />;
      case 'success':
        return <FiCheckCircle className="alert-icon alert-icon-success" />;
      case 'info':
      default:
        return <FiInfo className="alert-icon alert-icon-info" />;
    }
  };

  const handleOk = () => {
    if (onOk) onOk();
    onClose();
  };

  const handleCancel = () => {
    if (onCancel) onCancel();
    onClose();
  };

  return (
    <div className="alert-modal-overlay" onClick={onClose}>
      <div className={`alert-modal alert-modal-${type}`} onClick={(e) => e.stopPropagation()}>
        <div className="alert-modal-header">
          <div className="alert-modal-title-wrapper">
            {getIcon()}
            <h2 className="alert-modal-title">{title}</h2>
          </div>
          <button className="alert-modal-close" onClick={onClose}>
            <FiX size={24} />
          </button>
        </div>

        <div className="alert-modal-body">
          {typeof message === 'string' ? (
            <p className="alert-modal-message">{message}</p>
          ) : (
            message
          )}
        </div>

        <div className="alert-modal-footer">
          {showCancel && (
            <button className="alert-modal-button alert-modal-button-cancel" onClick={handleCancel}>
              {cancelText}
            </button>
          )}
          <button className={`alert-modal-button alert-modal-button-${type}`} onClick={handleOk}>
            {okText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;